import { ColorResult, color, hexToHsva, validHex } from '@uiw/react-color';

/**
 * Normalizes a hex color string by:
 * 1. Adding '#' prefix if missing
 * 2. Truncating to 7 characters (# + 6 hex digits)
 * 3. Ensuring uppercase for consistency
 */
const normalizeHexString = (hex: string): string => {
	// Remove any whitespace and convert to uppercase
	let normalized = hex.trim().toUpperCase();
	
	// Add # prefix if missing
	if (!normalized.startsWith('#')) {
		normalized = '#' + normalized;
	}
	
	// Truncate to 7 characters (# + 6 hex digits)
	if (normalized.length > 7) {
		normalized = normalized.substring(0, 7);
	}
	
	return normalized;
};

/**
 * Converts a hex color string to a ColorResult object
 * @param hex - Raw hex color string (with or without #, any length)
 * @param opacity - Optional opacity value (0-1), defaults to 1
 * @returns ColorResult object, defaults to black if invalid hex
 */
const hexToReactColorResult = (hex: string, opacity = 1): ColorResult => {
	const normalizedHex = normalizeHexString(hex);
	
	// Validate the normalized hex string
	if (!validHex(normalizedHex)) {
		console.warn(`Invalid hex color "${hex}" normalized to "${normalizedHex}", defaulting to black`);
		return color('#000000');
	}
	
	// Handle opacity
	if (opacity === 1) {
		return color(normalizedHex);
	}
	
	// Apply opacity by converting to HSVA and setting alpha
	const hsva = hexToHsva(normalizedHex);
	return color({ ...hsva, a: opacity });
};

export default hexToReactColorResult;